import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'src/makeStyles';
import { Collapse, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { colors, fontSize } from '../../constants/styleConstants';
import CardBox from '../CardBox';

export const useTableCardStyles = makeStyles()(theme => ({
  cardTitle: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: colors.background.gray,
    padding: 14,
    position: 'relative',
  },
  cardTitleText: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  mainInfoElements: {
    width: '100%',
    display: 'flex',
    padding: '9px 0',
    borderBottom: `1px solid ${colors.linesGray}`,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: 0,
    },
  },
  mainInfoItem: {
    flex: 1,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRight: `1px solid ${colors.linesGray}`,
    '&:last-child': {
      borderRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      borderRight: 0,
      flexDirection: 'row',
      alignItems: 'center',
      '&:last-child': {
        borderTop: `1px solid ${colors.linesGray}`,
      },
    },
  },
  infoElement: {
    display: 'block',
    width: '100%',
    padding: 10,
    borderBottom: `1px solid ${colors.linesGray}`,
    '&:last-child': {
      borderBottom: 0,
    },
  },
  infoTitle: {
    display: 'block',
    fontSize: fontSize.table,
    color: colors.textGray,
    [theme.breakpoints.down('sm')]: {
      marginRight: '1rem',
    },
  },
  iconButton: {
    padding: 0,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  expandBlock: {
    width: '100%',
  },
  link: {
    color: colors.blue,
  },
  avatar: {
    width: 45,
    height: 45,
    borderRadius: '50%',
    marginRight: 20,
  },
}));

const FbTableCard = ({ children, cardTitle }) => {
  const { classes, cx } = useTableCardStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <CardBox>
      {cardTitle ? (
        <>
          <div className={classes.cardTitle}>
            {cardTitle}
            <IconButton
              className={cx(classes.iconButton, classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              size="large"
            >
              <ArrowDropDownIcon />
            </IconButton>
          </div>
          <Collapse in={expanded} timeout="auto" unmountOnExit classes={{ root: classes.expandBlock }}>
            {children}
          </Collapse>
        </>
      ) : (
        children
      )}
    </CardBox>
  );
};

FbTableCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  cardTitle: PropTypes.element,
};

export default FbTableCard;
